import { render, staticRenderFns } from "./TabHistory.vue?vue&type=template&id=6dbb876c&scoped=true"
import script from "./TabHistory.vue?vue&type=script&lang=js"
export * from "./TabHistory.vue?vue&type=script&lang=js"
import style0 from "./TabHistory.vue?vue&type=style&index=0&id=6dbb876c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb876c",
  null
  
)

export default component.exports